import BlockFullImage1Col from 'src/components/Common/BlockFullImage1Col'

export default function Halloween() {
  return (
    <BlockFullImage1Col
      title={['halloween.title']}
      subtitle={['halloween.subtitle']}
      bgColor='#000'
      video='https://gemvision.com/Images/Halloween_2024.mp4'
      titleColor='#fff'
      videoOpacity
    />
  )
}
